<template>
  <div class="tpl-bd">
    <custom-dialog class="afterSaleRole-item-dialog" width="600px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body" style="padding: 0 24px !important">
        <div class="search-hd">
          <el-form @submit.native.prevent>
            <el-form-item>
              <h1 class="title">{{ userTips }}</h1>
            </el-form-item>
            <!-- <el-form-item style=" margin-right: 0">
              <el-input
                :placeholder="$t('placeholder_area_name')"
                v-model="filterText"
                clearable
                @input="change"
                style="width: 100%;"
              ></el-input>
            </el-form-item> -->
          </el-form>
        </div>
        <!-- 区域树 -->
        <div class="box ub-f1" style="padding: 10px; margin-bottom: 24px; border: 1px solid #dee2e6; height: 350px; overflow-y: auto">
          <el-tree ref="tree1" show-checkbox node-key="code" :props="{ label: 'name', children: 'children' }" :data="nationRegionTree" :filter-node-method="filterNode"></el-tree>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveCityCode">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import languageInjectMixins from '@/mixins/language_inject_mixins';

export default {
  mixins: [dialogMixins, languageInjectMixins],
  data() {
    return {
      filterText: '',
      nationRegionTree: [],
      cityListSelected: [],
      cityCodeListVal: [],
    };
  },
  mounted() {
    // this.initDialog();
    this.getTreeRegionTree();
  },
  computed: {
    userTips() {
      return this.$t('asm_userArea_item_dialog.wygoszfwqy', [this.model.data.userName]);
    },
  },
  methods: {
    // 初始化
    // initDialog: function () {

    // },
    getTreeRegionTree: function () {
      this.$getJSON(apis.NationRegionTree, { level: 3, status: 1 }).then((res) => {
        this.nationRegionTree = res.data;
        this.getCompanyDetail();
      });
    },

    getCompanyDetail: function () {
      if (!this.model.data.orgId) {
        return;
      }
      this.$getJSON(apis.CrmServiceAreaList, {
        orgId: this.model.data.orgId,
      }).then((res) => {
        const cityCodeList = res.data;
        this.cityCodeListVal = cityCodeList.map(i => i.cityCode);
        if (this.cityCodeListVal) {
          this.$nextTick(() => {
            this.$refs.tree1.filter(this.cityCodeListVal);
          });

          if (this.model.data.cityCode) {
            const cityListSelected = this.model.data.cityCode.split(',');
            this.$nextTick(() => {
              this.$refs.tree1.setCheckedKeys(cityListSelected);
            });
          }
        }
      });
    },
    change: function () {
      this.$refs.tree1.filter(this.cityCodeListVal);
    },

    // 未选择树过滤
    filterNode(values, data) {
      if (this.filterText) {
        return values.includes(data.code) && data.name.includes(this.filterText);
      } else {
        return values.includes(data.code);
      }
    },

    // 保存基本信息
    saveCityCode: function () {
      const selectNodes = this.$refs.tree1.getCheckedNodes();
      const list = selectNodes
        .filter(t => !t.children)
        .map(f => ({
          // afterServiceId: this.item.partnerOrgId,
          // afterServiceName: this.item.partnerName,
          cityCode: f.code,
          cityName: f.name,
        }));
      const params = { ...this.model.data };
      params.partnerId = this.companyId;
      params.areaList = list;
      this.$postJSON(apis.userAreaSetup, params).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
.afterSaleRole-item-dialog {
  .dialog-body {
    overflow: hidden;
  }
}
</style>
